import createWebIcon from "../createWebIcon";
import type { IconProps } from "../Icon.props";
import validateKeys from "../validateKeys";

export default function Login({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Login.Outline {...props} /> : <Login.Solid {...props} />;
}

Login.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Login.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M7.71805 7.08614C7.71805 4.63514 9.77784 2.64014 12.3095 2.64014H17.3418C19.8672 2.64014 21.9219 4.63014 21.9219 7.07614V18.1921C21.9219 20.6441 19.8631 22.6401 17.3315 22.6401H12.2992C9.77371 22.6401 7.71805 20.6491 7.71805 18.2021V17.2621V7.08614Z"
          className="icon-secondary"
        />
        <path
          d="M16.4593 12.094L13.4914 9.18496C13.1846 8.88496 12.691 8.88496 12.3853 9.18696C12.0805 9.48896 12.0816 9.97596 12.3873 10.276L14.0124 11.869H3.70397C3.2723 11.869 2.92188 12.214 2.92188 12.64C2.92188 13.065 3.2723 13.409 3.70397 13.409H14.0124L12.3873 15.003C12.0816 15.303 12.0805 15.79 12.3853 16.092C12.5386 16.243 12.7387 16.319 12.9398 16.319C13.1389 16.319 13.339 16.243 13.4914 16.094L16.4593 13.185C16.6065 13.04 16.6898 12.844 16.6898 12.64C16.6898 12.435 16.6065 12.239 16.4593 12.094Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
